import * as z from 'zod';
import '../../../../context.mjs';
import '../../../action-item/action-item.dto.mjs';
import '../../admin-user.dto.mjs';
import '../../agency/agency.dto.mjs';
import '../../agency/carrier-agency-relationships.dto.mjs';
import '../../company-credit-report.dto.mjs';
import '../../company-credit-report-preview.dto.mjs';
import '../../financial-period/admin-balance-sheet.dto.mjs';
import '../../financial-period/admin-financial-period.dto.mjs';
import '../../financial-period/admin-income-statement.dto.mjs';
import '../../individual-credit-report.dto.mjs';
import '../../individual-credit-report-preview.dto.mjs';
import '../../individual-ofac-check.dto.mjs';
import '../../individual-ofac-check-preview.dto.mjs';
import '../../note/admin-note.dto.mjs';
import '../../note/admin-note-topic.dto.mjs';
import '../../pel-pml.dto.mjs';
import '../../sfaa-class-experience.dto.mjs';
import './admin-account.dto.mjs';
import './bonding-line/admin-account-bonding-lines.dto.mjs';
import './contact/company-contact.dto.mjs';
import './contact/individual-contact.dto.mjs';
import '../bond/admin-surety-bond.dto.mjs';
import '../bond-form/surety-bond-form.dto.mjs';
import '../../../surety/bond-number/bond-number.dto.mjs';
import '../carrier-bonding-line/admin-surety-account-bonding-line.dto.mjs';
import { Upload } from '../indemnity-agreement/surety-indemnity-agreement.dto.mjs';
import '../quote/admin-quote.dto.mjs';
import { SuretyQuote } from '../quote/surety-quote.dto.mjs';
import '../../underwriter-assignment.dto.mjs';
import { Get as Get$2 } from '../../wip-statement/admin-wip-statement.dto.mjs';
import '../../../agent/index.mjs';
import '../../../carrier/carrier-preview.dto.mjs';
import '../../../comment/comment.dto.mjs';
import '../../../company/company.dto.mjs';
import { Admin as Admin$1 } from '../../../credit-report/company-credit-report.dto.mjs';
import { Admin, OFAC } from '../../../credit-report/individual-credit-report.dto.mjs';
import '../../../decisioning/decisioning.dto.mjs';
import '../../../email-ingest/email-ingest.dto.mjs';
import '../../../entity-tag/index.mjs';
import '../../../feature-flag/feature-flag.dto.mjs';
import '../../../financial-extraction/financial-extraction.dto.mjs';
import '../../../follower/follower.dto.mjs';
import '../../../individual/individual.dto.mjs';
import '../../../market-intelligence/fred.dto.mjs';
import '../../../naics-code/index.mjs';
import '../../../prompt-runner/application-extraction.dto.mjs';
import '../../../prompt-runner/bond-request-extraction.dto.mjs';
import '../../../prompt-runner/classification.dto.mjs';
import '../../../prompt-runner/extraction.dto.mjs';
import '../../../prompt-runner/report-brief.dto.mjs';
import '../../../prompt-runner/webhook.dto.mjs';
import '../../../report/render-report.dto.mjs';
import '../../../sfaa-code/index.mjs';
import { metadataSchema as metadataSchema$1, Create as Create$2 } from '../../../surety/account/surety-account.dto.mjs';
import '../../../surety/application-extraction/application-extraction.dto.mjs';
import '../../../surety/bond/surety-bond.dto.mjs';
import '../../../surety/bond/term/surety-bond-term.dto.mjs';
import '../../../surety/bond-form/surety-bond-form.dto.mjs';
import '../../../surety/bond-form/surety-bond-form-template.dto.mjs';
import '../../../surety/bond-issuance/surety-bond-issuance.dto.mjs';
import '../../../surety/bond-request-extraction/bond-request-extraction.dto.mjs';
import '../../../surety/financial-period/financial-extraction-attach.dto.mjs';
import '../../../surety/indemnity/indemnity-agreement.dto.mjs';
import '../../../surety/quote/contract/contract-extraction.dto.mjs';
import '../../../surety/quote/surety-quote.dto.mjs';
import '../../../tag/index.mjs';
import '../../../user/user.dto.mjs';
import '../../../wip/extraction.dto.mjs';
import '../../../wip/line-item.dto.mjs';
import '../../../wip/project.dto.mjs';
import '../../../wip/review.dto.mjs';
import '../../../wip/statement.dto.mjs';
import '../../../wip-statement/wip-statement.dto.mjs';
import { nameSuffixSchema, suretyAccountStatusSchema, SuretyAccountStatus, closedReasonSchema, CLOSED_REASON_NOTE_MAX_LENGTH, SuretyAccountUnderwritingStatus, SuretyType, suretyTypeSchema } from '../../../../enums.mjs';
import '../../../../types/actor/actor.mjs';
import { partialAddressSchema, addressSchema } from '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { lastName, firstName, individualContactId, email, decryptedSSN, companyContactId, fein, userId, isoDateTimeSchema, suretyAccountId, agencyId, rateSchemaV2, carrierName, fileId } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/bonding-line.mjs';
import { ContactRelationshipConfig, Exposure } from '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import { attachmentSchema, publishableSuretyAccountBondingLineSchema, nonNegativeCurrencySchema, coerceBondingLinePublish } from '../../../../types/utils.mjs';
import 'ts-pattern';
import '../../../../utils/describe-fred-change.util.mjs';
import 'luxon';
import '../../../../utils/extractable-extension.util.mjs';
import '../../../../utils/financial-analysis-metrics.util.mjs';
import '../../../../utils/normalize-us-state.util.mjs';
import { validateCloseRequiredFields } from '../../../../utils/validate-close-required-fields.util.mjs';
import '../../../../utils/wip-extraction-readiness.util.mjs';
import { Get as Get$3 } from '../../../surety/bond/preview/surety-bond-preview.dto.mjs';
import { Get as Get$4 } from '../../../surety/quote/preview/surety-quote-preview.dto.mjs';
import { Get as Get$1, Update as Update$1 } from './contract/admin-contract-surety-account.dto.mjs';
import * as adminContractSuretyAccount_dto from './contract/admin-contract-surety-account.dto.mjs';
export { adminContractSuretyAccount_dto as Contract };
import { Create as Create$1, limitsSchema } from '../../../surety/account/bonding-line/bonding-lines.dto.mjs';
import { Profitability } from '../../../../types/surety/account/contract/contract-surety-account.types.mjs';

const metadataSchema = metadataSchema$1;
var Metadata;
(function (Metadata) {
    (function (Get) {
        (function (Response) {
            Response.schema = metadataSchema;
        })(Get.Response || (Get.Response = {}));
    })(Metadata.Get || (Metadata.Get = {}));
})(Metadata || (Metadata = {}));
var Get;
(function (Get) {
    (function (Response) {
        let Individual;
        (function (Individual) {
            Individual.schema = z.object({
                id: individualContactId,
                type: z.literal("owner").optional(),
                firstName: firstName,
                middleInitial: z.string().optional(),
                lastName: lastName,
                suffix: nameSuffixSchema.optional(),
                address: partialAddressSchema.optional(),
                ssn: decryptedSSN.optional(),
                email: email.optional(),
                phone: z.string().optional(),
                spouse: z
                    .object({
                    id: individualContactId,
                    firstName: firstName,
                    middleInitial: z.string().optional(),
                    lastName: lastName,
                    suffix: nameSuffixSchema.optional(),
                    address: partialAddressSchema.optional(),
                    email: email.optional(),
                })
                    .optional(),
                ownsAHome: z.boolean().optional(),
                ofacCheck: OFAC.Admin.Response.schema.optional(),
                creditReports: z.array(Admin.Response.schema),
                config: ContactRelationshipConfig.schema.optional(),
            });
        })(Individual = Response.Individual || (Response.Individual = {}));
        let Company;
        (function (Company) {
            Company.schema = z.object({
                id: companyContactId,
                name: z.string(),
                address: addressSchema,
                fein: fein.optional(),
                creditReports: z.array(Admin$1.Response.schema),
                config: ContactRelationshipConfig.schema,
            });
        })(Company = Response.Company || (Response.Company = {}));
        Response.schema = z.object({
            id: suretyAccountId,
            agency: z.object({
                id: agencyId,
                displayName: z.string(),
            }),
            status: suretyAccountStatusSchema,
            displayName: z.string(),
            primaryCompanyId: companyContactId,
            closedReason: z.string().optional(),
            closedNote: z.string().optional(),
            companies: z.array(Company.schema),
            individuals: z.array(Individual.schema),
            fundNames: z.array(z.string()),
            adjustedFSR: z.number().optional(),
            averageFICO: z.number().optional(),
            quotes: z.array(Get$4.Response.schema),
            bonds: z.array(Get$3.Response.schema),
            exposure: Exposure.schema,
            wipStatements: z.array(Get$2.Response.schema),
            attachments: z.array(attachmentSchema()),
            contract: Get$1.Response.schema.optional(),
            metadata: Metadata.Get.Response.schema,
            isContractSuretyAccount: z.boolean(),
            createdAt: isoDateTimeSchema.nullable(),
            updatedAt: isoDateTimeSchema,
            underwriterUserId: userId,
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Update;
(function (Update) {
    (function (Status) {
        (function (Request) {
            const reOpenedSchema = z.object({
                status: z.literal(SuretyAccountStatus.review),
            });
            const closedSchema = z.object({
                status: z.literal(SuretyAccountStatus.closed),
                closedReason: closedReasonSchema,
                note: z.string().max(CLOSED_REASON_NOTE_MAX_LENGTH).optional(),
            });
            Request.schema = z
                .discriminatedUnion("status", [reOpenedSchema, closedSchema])
                .superRefine(validateCloseRequiredFields);
        })(Status.Request || (Status.Request = {}));
    })(Update.Status || (Update.Status = {}));
    (function (Underwriting) {
        (function (Status) {
            (function (Request) {
                Request.schema = z.discriminatedUnion("suretyType", [
                    Update$1.Underwriting.Status.Request.schema,
                ]);
                Request.optionalSchema = Update$1.Underwriting.Status.Request.optionalSchema;
            })(Status.Request || (Status.Request = {}));
        })(Underwriting.Status || (Underwriting.Status = {}));
        (function (Approve) {
            (function (Request) {
                Request.schema = z.object({
                    suretyType: z.literal(SuretyType.contract).default(SuretyType.contract),
                    status: z.literal(SuretyAccountUnderwritingStatus.approved),
                    bondingLines: Create$1.Request.baseSchema,
                    limits: limitsSchema.optional(),
                });
            })(Approve.Request || (Approve.Request = {}));
        })(Underwriting.Approve || (Underwriting.Approve = {}));
    })(Update.Underwriting || (Update.Underwriting = {}));
    (function (BondingLine) {
        (function (Request) {
            Request.schema = z.object({
                suretyType: suretyTypeSchema,
                bondingLine: publishableSuretyAccountBondingLineSchema,
            });
        })(BondingLine.Request || (BondingLine.Request = {}));
    })(Update.BondingLine || (Update.BondingLine = {}));
    (function (BondingLines) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [
                Update$1.BondingLines.Request.schema,
            ]);
        })(BondingLines.Request || (BondingLines.Request = {}));
    })(Update.BondingLines || (Update.BondingLines = {}));
    (function (Metadata) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("suretyType", [
                metadataSchema.extend({
                    suretyType: z.literal(SuretyType.contract),
                    updatedAt: isoDateTimeSchema,
                }),
            ]);
        })(Metadata.Request || (Metadata.Request = {}));
    })(Update.Metadata || (Update.Metadata = {}));
    (function (Profitability$1) {
        (function (Request) {
            Request.schema = Profitability.schema.omit({
                effectiveFyeYear: true,
            });
        })(Profitability$1.Request || (Profitability$1.Request = {}));
    })(Update.Profitability || (Update.Profitability = {}));
    (function (UnderwritingExpiration) {
        (function (Request) {
            Request.schema = Update$1.Underwriting.Request.schema;
        })(UnderwritingExpiration.Request || (UnderwritingExpiration.Request = {}));
    })(Update.UnderwritingExpiration || (Update.UnderwritingExpiration = {}));
})(Update || (Update = {}));
var BrokerOfRecord;
(function (BrokerOfRecord) {
    (function (Request) {
        Request.schema = z.object({
            agencyId: agencyId,
            agentUserId: userId,
            effectiveDate: isoDateTimeSchema,
        });
    })(BrokerOfRecord.Request || (BrokerOfRecord.Request = {}));
})(BrokerOfRecord || (BrokerOfRecord = {}));
var Create;
(function (Create) {
    (function (Request) {
        Request.accountSchema = Create$2.Request;
        Request.indemnityAgreementSchema = Upload.Request.schema;
        Request.bondingLineSchema = z.object({
            rate: rateSchemaV2,
            singleLimit: nonNegativeCurrencySchema,
            aggregateLimit: nonNegativeCurrencySchema,
            isPublished: z.boolean(),
        });
        Request.carrierBondingLineSchema = z.object({
            carrierName: carrierName,
            bondingLine: Request.bondingLineSchema.omit({ isPublished: true }),
        });
        const approvedSchema = z.object({
            status: z.literal(SuretyAccountUnderwritingStatus.approved),
            bondingLine: Request.bondingLineSchema.transform(coerceBondingLinePublish),
            carrierBondingLines: z.array(Request.carrierBondingLineSchema),
        });
        const declinedSchema = z.object({
            status: z.literal(SuretyAccountUnderwritingStatus.declined),
        });
        Request.accountTermsSchema = z.preprocess((val) => (val && typeof val === "object" && "status" in val && val.status ? val : undefined), z.discriminatedUnion("status", [approvedSchema, declinedSchema]).optional());
        const baseRequestFields = {
            agentId: userId,
            followers: z
                .array(userId, { error: "At least one follower is required" })
                .min(1, "At least one follower is required"),
            underwriterId: userId,
            terms: Request.accountTermsSchema,
            indemnityAgreement: z
                .object({
                fileId: fileId,
            })
                .optional(),
            quote: SuretyQuote.Create.Request.quoteSchemaForAccountCreation.optional(),
            bondTerms: SuretyQuote.Create.Request.optionalBondTermsSchema,
        };
        Request.schema = z.object({
            aiEnabled: z.literal(true),
            ...baseRequestFields,
            account: Create$2.Request.aiAccountSchema,
        });
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));

export { BrokerOfRecord, Create, Get, Metadata, Update };
